import React, { useState } from 'react';
import { useContent, useCompany } from '../context/ContentContext';
import { PageBanner } from './About';
import { MapPin, Phone, Mail } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { useToast } from '../hooks/use-toast';
import { sendEnquiry } from '../lib/sendEnquiry';

export default function Contact() {
  const companyInfo = useCompany();
  const { site_content } = useContent();
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await sendEnquiry(form, 'Contact Form');
    setSubmitting(false);
    toast({
      title: ok ? 'Message sent' : 'Message saved',
      description: ok
        ? 'Thanks for getting in touch. We will respond soon.'
        : 'Could not reach mail server. Your message is saved locally — please call +91-9911565091.',
    });
    setForm({ name: '', phone: '', email: '', subject: '', message: '' });
  };

  return (
    <div>
      <PageBanner title={site_content?.page_contact_title || 'Contact Us'} />
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-3 gap-5 mb-12">
          <div className="bg-[#fffaf0] border border-[#f4e6c6] rounded-lg p-6 text-center hover:shadow-md transition-all">
            <div className="w-14 h-14 rounded-full bg-[#f7941e] text-white flex items-center justify-center mx-auto mb-3"><MapPin className="w-6 h-6" /></div>
            <h3 className="font-display uppercase tracking-wide text-gray-900 mb-2">Address</h3>
            <p className="text-sm text-gray-600">{companyInfo.address}</p>
          </div>
          <div className="bg-[#fffaf0] border border-[#f4e6c6] rounded-lg p-6 text-center hover:shadow-md transition-all">
            <div className="w-14 h-14 rounded-full bg-[#f7941e] text-white flex items-center justify-center mx-auto mb-3"><Mail className="w-6 h-6" /></div>
            <h3 className="font-display uppercase tracking-wide text-gray-900 mb-2">Send your mail at</h3>
            {companyInfo.email.map((l) => (
              <a key={l} href={`mailto:${l}`} className="block text-sm text-gray-600 hover:text-[#f7941e]">{l}</a>
            ))}
          </div>
          <div className="bg-[#fffaf0] border border-[#f4e6c6] rounded-lg p-6 text-center hover:shadow-md transition-all">
            <div className="w-14 h-14 rounded-full bg-[#f7941e] text-white flex items-center justify-center mx-auto mb-3"><Phone className="w-6 h-6" /></div>
            <h3 className="font-display uppercase tracking-wide text-gray-900 mb-2">Have Any Question</h3>
            {companyInfo.contacts.map((c) => (
              <div key={c.phone} className="mt-2">
                <p className="font-display text-sm uppercase tracking-wide text-[#e67e00]">{c.name}</p>
                <a href={`tel:${c.phone}`} className="text-sm text-gray-700 hover:text-[#f7941e]">{c.phone}</a>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="font-display text-2xl uppercase text-gray-900 mb-2">Send Message</h2>
            <div className="w-16 h-1 bg-[#f7941e] mb-5 rounded" />
            <form onSubmit={submit} className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <Input placeholder="Your Name *" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
                <Input placeholder="Phone *" required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <Input placeholder="Email" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                <Input placeholder="Subject" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} />
              </div>
              <Textarea placeholder="Your Message" rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} />
              <button type="submit" className="btn-brand">Send Message</button>
            </form>
          </div>
          <div className="rounded-lg overflow-hidden shadow-lg min-h-[360px]">
            <iframe title="location" className="w-full h-full min-h-[360px]" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.1!2d77.1!3d28.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDQ1JzAwLjAiTiA3N8KwMDYnMDAuMCJF!5e0!3m2!1sen!2sin!4v1700000000000" loading="lazy" allowFullScreen></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
